export default __webpack_public_path__ + "static/media/Thumb_Skin_chrome.76b3395b.png";